import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
export default {
  name: 'mng_switch',
  data: function data() {
    return {
      pageConfig: {
        editPageName: '开关',
        addFunName: 'mngSwitchAdd',
        modifyFunName: 'mngSwitchModify',
        delFunName: 'mngSwitchDel',
        queryFunName: 'mngSwitchQuery',
        detailFunName: 'mngSwitchDetail',
        clearCache: 'mngSwitchClearCache'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        code: null,
        name: null,
        switchValue: false,
        remark: null,
        allowDel: false
      },
      rules: {
        code: [{
          required: true,
          message: '代码不能为空',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '名称不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    changeSwitch: function changeSwitch(row) {
      var _this = this;
      this.$confirm('确定调整吗？').then(function () {
        _this.$api[_this.pageConfig.modifyFunName](_this.saveFormDataProcess(row)).then(function (res) {
          if (res.data) {
            _this.$message.success('编辑成功');
          } else {
            row.switchValue = !row.switchValue;
            _this.$message.error('编辑失败');
          }
        });
      });
    },
    refresh: function refresh() {
      var _this2 = this;
      this.$prompt('请输入代码刷新', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (_ref) {
        var value = _ref.value;
        _this2.$api[_this2.pageConfig.clearCache](value).then(function (res) {
          _this2.$message.success('操作成功');
        });
      }).catch(function () {});
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this3 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this3.initFormData(res.data);
        _this3.editDialogTitle = _this3.pageConfig.editPageName + '维护';
        _this3.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this4 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this4.$api[_this4.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this4.$message.success('删除成功');
            _this4.query();
          } else {
            _this4.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this5 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this5.tableData = res.data || [];
        _this5.totalCount = res.count;
        _this5.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this6 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this6.formData.id) {
            _this6.$api[_this6.pageConfig.modifyFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('编辑成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('编辑失败');
              }
            });
          } else {
            _this6.$api[_this6.pageConfig.addFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('新增成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};